import React from "react";
import { Message } from "../../entities/Message";
import { SvgRadius } from "../../entities/ChatSettingsV2";
import { StandardMessageComponent } from "./StandardMessageComponent";
import { ConnectingToAgentMessageComponent } from "./ConnectingToAgentMessageComponent";
import { AgentJoinedMessageComponent } from "./AgentJoinedMessageComponent";
import { CloseChatMessageComponent } from "./CloseChatMessageComponent";
import { FileMessageComponent } from "./FileMessageComponent";
import { ErrorMessageComponent } from "./ErrorMessageComponent";
import { RequestEmailMessageComponent } from "./RequestEmailMessageComponent";
import { FormSingleSelectMessageComponent } from "./FormSingleSelectMessageComponent";
import { RequestEmailFormComponent } from "./RequestEmailFormComponent";
import { RequestFirstEmailMessageComponent } from "./RequestFirstEmailMessageComponent";

type MessageComponentProps = Message & {
  customSVG: string;
  userAvatarSVG?: string;
  svgRadius?: SvgRadius;
  isLastMessage: boolean;
  showAvatar: boolean;
  showTimestamp: boolean;
  thinking: boolean;
  showUserBackground?: boolean;
  onEscalate: () => Promise<void>;
  onEscalationEmail: (email: string, additionalData?: any) => Promise<void>;
  onFirstEscalationEmail: (email: string, additionalData?: any) => Promise<void>;
  tenant: string;
  quackAgentName: string;
  chatEnded: boolean;
  sendFormOptionSelected: (formId: string, option: string) => Promise<void>;
  track?: (eventName: string, properties: any) => void;
  chatSessionId?: string;
  getJourney?: () => any[];
  getDom?: () => string;
  onClose?: () => void;
  userEmail?: string;
  contextArrowsHelperConfiguration?: {
    isToggleOn: boolean;
    emails: string[];
  };
};

export function MessageComponent(props: MessageComponentProps) {
  if (props.action === "standard_message" && props.author === "USER") {
    return <StandardMessageComponent {...props} orientation={"right"} showInitials />;
  }

  if (props.action === "standard_message" && props.author === "LIVE_AGENT") {
    return <StandardMessageComponent {...props} orientation={"left"} showInitials />;
  }

  if (props.action === "standard_message" && props.author !== "LIVE_AGENT") {
    return <StandardMessageComponent {...props} orientation={"left"} />;
  }

  if (props.action === "connecting_to_agent") {
    return <ConnectingToAgentMessageComponent {...props} />;
  }

  if (props.action === "agent_joined") {
    return <AgentJoinedMessageComponent {...props} />;
  }

  if (props.action === "close_chat") {
    return <CloseChatMessageComponent {...props} />;
  }

  if (props.action === "file_uploaded") {
    return (
      <FileMessageComponent
        orientation={"right"}
        url={props.data.url}
        filename={props.data.filename}
        createdAt={props.createdAt}
        showTimestamp={props.showTimestamp}
        thinking={props.thinking}
        isLastMessage={props.isLastMessage}
      />
    );
  }

  if (props.action === "file") {
    return (
      <FileMessageComponent
        orientation={props.author === "LIVE_AGENT" ? "left" : "right"}
        url={props.data.url}
        filename={props.data.filename}
        createdAt={props.createdAt}
        showTimestamp={props.showTimestamp}
        thinking={props.thinking}
        isLastMessage={props.isLastMessage}
      />
    );
  }

  if (props.action === "error") {
    return <ErrorMessageComponent {...props} />;
  }

  if (props.action === "request_email") {
    if (props.tenant === "dremio") {
      return <RequestEmailFormComponent {...props} />;
    }
    return <RequestEmailMessageComponent {...props} />;
  }

  if (props.action === "first_request_email") {
    return <RequestFirstEmailMessageComponent {...props} />;
  }

  if (props.action === "form_single_select") {
    return <FormSingleSelectMessageComponent {...props} />;
  }

  return <></>;
}
